__turbopack_context__.v({
  "btnContainer": "JoA1eq_btnContainer",
  "content": "JoA1eq_content",
  "downloadBtns": "JoA1eq_downloadBtns",
  "hero": "JoA1eq_hero",
  "noiseBg": "JoA1eq_noiseBg",
  "scaleAnim": "JoA1eq_scaleAnim",
  "subtitle": "JoA1eq_subtitle",
  "uhLogo": "JoA1eq_uhLogo",
});
